import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import CssBaseline from '@mui/material/CssBaseline';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import {
  BrowserRouter,
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';
import './styles/global.scss';
import './multilingual/index'
import App from 'App';
import ErrorFallback from 'component/dialogs/ErrorFallback';
import { ErrorBoundary } from 'react-error-boundary';


let logLevelDisable = {
  log: [0, 2, 4, 6],
  warn: [0, 1, 4, 5],
  error: [0, 1, 2, 3],
};

const disableAllLogs = () => {
  console.log = () => { };
  console.warn = () => { };
  console.error = () => { };
  console.assert = () => { };
};

// If you want to enable logs, add logs as a key in localStorage
if (!localStorage.getItem('logs')) {
  disableAllLogs();
} 
// else {
//   let logLevel = Number(localStorage.getItem('logs'));
//   if (!isNaN(logLevel)) {
//     Object.keys(logLevelDisable).forEach(n => {
//       if (logLevelDisable[n].includes(logLevel)) {
//         console[n] = () => { };
//       }
//     });
//   } else {
//     disableAllLogs();
//   }
// }

const logError = (error, info) => {
	console.log(error, info)
}

ReactDOM.render(
  <React.Fragment>
    <CssBaseline />
    <Provider store={store}>
      {/* <RouterProvider router={rootRoutes} /> */}
      <BrowserRouter>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onError={logError}
        >
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </Provider>
  </React.Fragment>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
